// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gaCL","col":"styles_col__2RcdA"};